//无需添加验证头部的url,参数在不在路径上的开放,比如/api-uaa/oauth/user/token?参数=xxx这种,则在下面的数据添加/api-uaa/oauth/user/token: true
export const ingoreAddUrls = {
  '/api-uaa/oauth/user/token': true,
  '/api-user/user/register': true,
  '/api-orga/orgamas/list': true,
  '/api-uaa/oauth/email/token': true,
  '/api-basis/basistoolsclassify/listLogo': true,
  '/api-basis/basis/language/list': true,
  '/api-course/coursemas/findIndexCourseMas' : true,
  '/api-course/coursemas/findIIOECourseMas' : true,
  '/api-user/thirdlogion/doTyLogin' : true,
  '/api-course/coursemas/findCourseTrainPage': true,
  '/api-course/courseexperttrain/listExpert': true,
  '/api-course/coursemas/findTrainIndex': true,
  '/api-orga/orgainformmas/listAll': true,
  '/api-orga/orgainformmas/listTrain': true,
  '/api-course/coursetrain/findTrainAll': true,
  '/api-course/mana/coursetrainexpert/list': true,
  '/api-course/courseexpertrecommend/findCourseLanguaList': true,
  '/api-course/coursetrainhelp/findAllQuestions': true,
  '/api-basis/coursedetailsmodule/findListEdtails' : true,
  '/api-course/coursemas/findExpertCourse' : true,
  '/api-course/coursestaff/listExpert' : true,
  '/api-course/coursecreditcount/findByCreditType' : true,
  '/api-course/coursecreditcount/findSchoolCredit' : true,
  '/api-course/coursecreditcount/findPeopleCredit' : true,
  '/api-course/coursetrain/findTrainList' : true,
  '/api-course/basiscoursetag/findAll' : true,
  '/api-basis/basisstage/findAllStage' : true,
  '/api-basis/basissubject/findByStageId' : true,
  '/api-uaa/oauth/token' : true,
  '/api-uaa/oauth/ccih/login' : true,
  '/api-uaa/oauth/wx/pc/getAuthorize' : true,
  '/api-uaa/oauth/wx/pc/token' : true,
  '/api-course/statistics/getPyNewTeacherTrain':true,
  '/api-course/statistics/getPySubjectStatisticsData':true
}
//无需添加验证头部的url,参数在路径上的开放,比如/api-orga/orgamas/1,则在下面的数据添加/api-orga/orgamas/
export const ingoreSimilarUrls = ['/api-uaa/oauth/srsc/token','/api-uaa/oauth/openId/token', '/api-orga/orgamas/', '/api-sms/verificationcode/email', 
'/api-basis/basislangukeyword/languKeyWordByLanguage/', '/api-course/coursetrain/findOne/', 
'/api-course/coursetrainmodule/list/', '/api-course/mana/coursetrainbanner/bannerListByTrainId/', '/api-course/coursetrainbanner/bannerListByTrainId/', 
'/api-course/courseparamconfig/findParamConfig/', '/api-orga/orgainformmas/', '/api-course/coursetrainmodule/list/',
'/api-course/coursecomprob/listFractioniz/', '/api-course/coursemas/findSignUpList/', '/api-course/coursemas/findById/',
'/api-basis/basisregion/findByParentCode/', '/api-course/coursemas/countCourseMas/', '/api-course/coursemas/countOverviewColumns/',
'/api-course/coursemas/countSigupTrend/', '/api-course/coursemas/countSigupFinishTrend/', '/api-course/coursemas/questionnaireRate/',
'/api-course/coursemas/examPassRate/', '/api-course/coursestaff/list/', '/api-course/coursecomprob/findComProb/',
'/api-course/coursechapter/chapter/', '/api-course/coursedetails/findDetails/', '/api-course/coursemas/courseAssessRate/',
'/api-course/coursemas/courseFinishRate/', '/api-course/coursemas/countCourseByRegion/', '/api-course/coursemas/countCourseProject/',
'/api-course/coursemas/countCourseTrainBySum/', '/api-course/coursemas/countCourseProjectByRegion/', '/api-course/coursemas/countCourseProjectBySum/',
'/api-course/coursemas/countCourse/', '/api-course/datastatistics/', '/api-course/courseoperation/checkExportTrainAnnal/',
'/api-user/check/phone']

import courseDefaultImg from '@/assets/img/no_pictures.png';
import ImNoContent from '@/assets/img/no_content.png'
import srscLogoUrl from '@/assets/images/home/srsc_logo.png'
import headerImg from '@/assets/images/home/default_head_login.png'

// 移动端域名
export const phoneUrl = process.env.h5Server
// 项目名
export const ctx = ''
// 网站标题
export const indexTitle = '研训云'
// 课程默认封面图
export const courseCoverImg = courseDefaultImg
// 暂无图片
export const defaultImg = courseDefaultImg
// 暂无内容
export const noContentImg = ImNoContent
// 默认头像
export const defaultHeaderImg = headerImg
// 双融双创logo
export const srscLogo = srscLogoUrl
// 双融双创网址
export const srscUrl = process.env.srscServer
// 机构申请地址
export const srscAddSchool= process.env.srscServer + '/login/schoolApply.jsp'
// 课程详情模块 视频默认封面图
export const defaultVideoCover = 'srsc/2020-06-22/1592808129642-201.jpg'
// 直播websocket url
export const websocketPath = 'wss://ws.zsgen.com/websocket/'
// 题目选项
export const quesOption = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']
// 中文序号
export const cNumIndex = ['一','二','三','四','五','六','七','八','九']
// 机构用户导入模板
export const moduleExel = 'http://172.16.25.199:8888/group1/M00/00/00/rBAZx13TTOiAXDFwAAAnOa4Yg2Y46.xlsx'
// 机构院系导入模板
export const moduleDeptInfoExel = 'http://172.16.25.199:8888/group1/M00/00/00/rBAZx13U46mASR-LAAAm_7oBudo47.xlsx'
// 文件上传接口
export const fileUploadApi = '/api-file/open/upload/file'


// WEBPACK FOOTER //
// ./src/config/defaultSysUrls.js